import createPersistedState from 'vuex-persistedstate';
import router from '@/router/index';

const Settings = {
	namespaced: true,
	state: {
		resetStandardsList: false, // 重置标准列表-是否需要重置
		wechatBindShow: false, 
		loginShow: false, // 保留旧字段，兼容其他页面调用
		loginShowPersonal: false, // 个人登录弹窗
		loginShowEnterprise: false, // 企业登录弹窗
		registerShow: false,
		loginSuccessAct: '',
		// 企业选择弹窗
		companySelectorShow: false,
		pendingCompanyList: [],
		sBreadcrumbList: [
			{
				path: '/index/Home',
				name: '首页'
			}
		], //面包屑数据
		sLoginRouteList: ['Ai', 'StandardsPdf', 'StandardsDoc', 'Cart'],
		sNoFooterRouteList: ['Ai', 'StandardsPdf', 'StandardsDoc', 'BindPhone'],
		metaInfo: null,
		defaultTitle: '特规通', // 默认页面标题
		currentTitle: '特规通', // 当前页面标题
		error: false
	},

	getters: {
		sError(state) {
			return state.error;
		},
		resetStandardsList(state) {
			return state.resetStandardsList;
		},
		sBreadcrumbList(state) {
			return state.sBreadcrumbList;
		},
		sLoginRouteList(state) {
			return state.sLoginRouteList;
		},
		sNoFooterRouteList(state) {
			return state.sNoFooterRouteList;
		},
		sLoginShow(state) {
			console.log('sLoginShow', state.loginShow);
			return state.loginShow;
		},
		sLoginShowPersonal(state) {
			return state.loginShowPersonal;
		},
		sLoginShowEnterprise(state) {
			return state.loginShowEnterprise;
		},
		sWechatBindShow(state) {
			// console.log('333',state.wechatBindShow)
			return state.wechatBindShow;
		},
		sRegisterShow(state) {
			return state.registerShow;
		},
		sLoginSuccessAct(state) {
			return state.loginSuccessAct;
		},
		sCompanySelectorShow(state) {
			return state.companySelectorShow;
		},
		sPendingCompanyList(state) {
			return state.pendingCompanyList;
		},
		sMetaInfo(state) {
			return state.metaInfo;
		},
		defaultTitle(state) {
			return state.defaultTitle;
		},
		currentTitle(state) {
			return state.currentTitle;
		}
	},

	mutations: {
		SET_ERROR(state, error) {
			state.error = error;
		},
		SET_RESET_STANDARDS_LIST(state, reset) {
			state.resetStandardsList = reset;
		},
		SET_BREADCRUMB_LIST(state, list) {
			state.sBreadcrumbList = list;
		},
		SET_KEEPALIVE_LIST(state, list) {
			state.keepaliveList = list;
		},
		SET_LOGIN_SHOW(state, show) {
			state.loginShow = show;
		},
		SET_LOGIN_SHOW_PERSONAL(state, show) {
			state.loginShowPersonal = show;
		},
		SET_LOGIN_SHOW_ENTERPRISE(state, show) {
			state.loginShowEnterprise = show;
		},
		SET_WECHAT_BIND_SHOW(state, show) {
			// console.log('222',show)
			state.wechatBindShow = show;
		},
		SET_REGISTER_SHOW(state, show) {
			state.registerShow = show;
		},
		SET_LOGIN_SUCCESS_ACT(state, act) {
			state.loginSuccessAct = act;
		},
		SET_COMPANY_SELECTOR_SHOW(state, show) {
			state.companySelectorShow = show;
		},
		SET_PENDING_COMPANY_LIST(state, list) {
			state.pendingCompanyList = list;
		},
		SET_META_INFO(state, info) {
			state.metaInfo = info;
		},
		SET_CURRENT_TITLE(state, title) {
			state.currentTitle = title;
			document.title = title;
		},
		RESET_TITLE(state) {
			state.currentTitle = state.defaultTitle;
			document.title = state.defaultTitle;
		}
	},

	actions: {
		setError({ commit }, error) {
			commit('SET_ERROR', error);
		},
		setResetStandardsList({ commit }, reset) {
			// console.log('setResetStandardsList', reset);
			commit('SET_RESET_STANDARDS_LIST', reset);
		},
		setBreadcrumbList({ commit }, breadcrumbList) {
			commit('SET_BREADCRUMB_LIST', breadcrumbList);
		},
		setKeepaliveList({ commit }, list) {
			commit('SET_KEEPALIVE_LIST', list);
		},
		setLoginShow({ commit }, show) {
			console.log('setLoginShow', show);
			commit('SET_LOGIN_SHOW', show);
		},
		setLoginShowPersonal({ commit }, show) {
			commit('SET_LOGIN_SHOW_PERSONAL', show);
		},
		setLoginShowEnterprise({ commit }, show) {
			commit('SET_LOGIN_SHOW_ENTERPRISE', show);
		},
		setWechatBindShow({ commit }, show) {
			// console.log('111',show)
			commit('SET_WECHAT_BIND_SHOW', show);
		},
		setRegisterShow({ commit }, show) {
			commit('SET_REGISTER_SHOW', show);
		},
		setLoginSuccessAct({ commit }, act) {
			commit('SET_LOGIN_SUCCESS_ACT', act);
		},
		setCompanySelectorShow({ commit }, show) {
			commit('SET_COMPANY_SELECTOR_SHOW', show);
		},
		setPendingCompanyList({ commit }, list) {
			commit('SET_PENDING_COMPANY_LIST', list);
		},
		setMetaInfo({ commit }, info) {
			commit('SET_META_INFO', info);
		},
		setCurrentTitle({ commit }, title) {
			commit('SET_CURRENT_TITLE', title);
		},
		resetTitle({ commit }) {
			commit('RESET_TITLE');
		}
	}

	// plugins: [createPersistedState()]
};

export default Settings;
